import { Component } from "react";
import { AtomicBlockUtils } from "draft-js";

class QrSource extends Component {
	componentDidMount() {
		const { editorState, entityType, onComplete, data } = this.props;
		// console.log(data);

		if (data && data.imageUrl) {
			const styleString = window.prompt("Image styleString");
			const content = editorState.getCurrentContent();
			const contentWithEntity = content.createEntity(entityType.type, "IMMUTABLE", {
				src: data.imageUrl,
				styleString,
			});
			const entityKey = contentWithEntity.getLastCreatedEntityKey();
			const nextState = AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, " ");

			onComplete(nextState);
		} else {
			const src = window.prompt("Qr URL");
			const styleString = window.prompt("Qr styleString");
			const qrStyleData = window.prompt("Qr qrStyleData");
			if (src) {
				const content = editorState.getCurrentContent();
				const contentWithEntity = content.createEntity(entityType.type, "IMMUTABLE", { src, styleString, qrStyleData });
				const entityKey = contentWithEntity.getLastCreatedEntityKey();
				const nextState = AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, " ");

				onComplete(nextState);
			} else {
				onComplete(editorState);
			}
		}
	}

	render() {
		return null;
	}
}
export default QrSource;
